import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { RepeatIcon } from "lucide-react";
import { toast } from "sonner";
import { api, extractError } from "@/lib/api";

export function DesativarRecorrenciaButton({ recorrenciaId, descricao, onDone, testId, compact }) {
  const [open, setOpen] = useState(false);

  const confirmar = async () => {
    try {
      await api.post(`/financeiro/despesas-recorrentes/${recorrenciaId}/desativar`);
      toast.success("Recorrência desativada — histórico preservado");
      setOpen(false);
      onDone();
    } catch (e) {
      toast.error(extractError(e));
    }
  };

  return (
    <>
      <Button size="sm" variant="ghost" onClick={() => setOpen(true)} data-testid={testId}
        className="rounded-sm text-muted-foreground hover:text-destructive" title="Desativar Recorrência">
        <RepeatIcon size={14} className={compact ? "" : "mr-1"} />
        {!compact && "Desativar Recorrência"}
      </Button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent className="rounded-sm">
          <AlertDialogHeader>
            <AlertDialogTitle>Desativar Recorrência?</AlertDialogTitle>
            <AlertDialogDescription>
              <b>{descricao}</b> deixará de ser gerada nos próximos meses. Todas as despesas já
              lançadas (pagas e pendentes) permanecem no histórico financeiro.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="desativar-rec-cancelar">Cancelar</AlertDialogCancel>
            <AlertDialogAction onClick={confirmar} data-testid="desativar-rec-confirmar"
              className="bg-destructive text-white hover:bg-destructive/90">Desativar</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
